import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AuthService } from '@core/services/auth.service';
import { PageHeadingComponent } from '@shared/page-heading/page-heading.component';

import { GovukComponentsModule } from 'govuk-components';

@Component({
  selector: 'esos-start-login',
  template: `
    <div class="govuk-grid-row">
      <div class="govuk-grid-column-two-thirds">
        <esos-page-heading>Create a GOV.UK One Login or sign in</esos-page-heading>
        <div class="govuk-body">
          <p>
            You need a GOV.UK One Login to sign in to the ESOS service. You can create one if you do not already have
            one.
          </p>
          <button type="button" class="govuk-button" (click)="continue()">Continue</button>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageHeadingComponent, GovukComponentsModule],
})
export class StartLoginComponent implements OnInit {
  private redirectUrl: string = '';
  private email: string = '';

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.redirectUrl = params['redirectUrl'];
      this.email = params['email'];
    });
  }

  continue(): void {
    this.authService.login({ redirectUri: this.redirectUrl, loginHint: this.email });
  }
}
